export const VIEW_COMPANY = 'view_company';
export const VALIDATE_COMPANY = 'validate_company';
export const VALIDATE_COMPANY_ERROR = 'validate_company_error';
export const COMPANY_ERROR = 'company_error';
export const RECRUITER_ORG_DETAILS = 'recruiter_org_details';
export const APPROVE_ROLE = 'approve_role';
export const ADMIN_COMPANY_LIST = 'company_list';
export const ADMIN_JOB_LIST='job_list';
export const ADMIN_EMPLOYEE_LIST='employee_list';
